























import { Component, Vue, Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import SimpleDialogForm from "@/components/Forms/SimpleDialogForm.vue";
import { Observer } from "mobx-vue";
import collectionIssueEditStore from "@/store/collectionIssueEditStore";
import CollectionLetterHistory from "@/components/CollectionEvents/CollectionLetterHistory.vue";

@Observer
@Component({ components: { ValidationProvider, SimpleDialogForm, CollectionLetterHistory } })
export default class CollectionIssueLetterHistoryEditDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop({ default: "" }) dataCy?: string;

  collectionIssueEditStore = collectionIssueEditStore;

  handleCloseDialog() {
    this.$emit("collectionIssueLetterHistoryEditDialogClose");
  }

  deleteSelectedLetterHistory() {
    this.$emit("deleteSelectedLetterHistory");
  }

  destroyed() {
    collectionIssueEditStore.resetCollectionIssueEdit();
  }
}
